export const getAuthAndUser = () => {
  const user = localStorage.getItem('user');
  const authToken = localStorage.getItem('auth_token');
  const expiration = localStorage.getItem('authTokenExpiration');

  if (authToken && expiration && new Date(expiration) <= new Date()) {
    localStorage.clear();
    return { user: null, authToken: null };
  }

  return {
    user: user ? JSON.parse(user) : null,
    authToken: authToken ? JSON.parse(authToken) : null,
  };
};

export const setAuthAndUser = (authToken, user) => {
  if (authToken) {
    const expiresIn = 2 * 24 * 60 * 60 * 1000;
    // const expiresIn = 10 * 1000;
    const expirationDate = new Date(new Date().getTime() + expiresIn);

    localStorage.setItem('auth_token', JSON.stringify(authToken));
    localStorage.setItem('authTokenExpiration', expirationDate.toISOString());
  }
  if (user) {
    localStorage.setItem('user', JSON.stringify(user));
  }
};

export const removeAuthAndUser = () => {
  localStorage.removeItem('user');
  localStorage.removeItem('auth_token');
  localStorage.removeItem('expandedMenus');
  localStorage.removeItem('authTokenExpiration');
};

export const setTwoFactorAuth = (twoFactorAuth) => {
  if (twoFactorAuth) {
    localStorage.setItem('twoFactorAuth', JSON.stringify(twoFactorAuth));
  }
};

export const getTwoFactorAuth = () => {
  const twoFactorAuth = localStorage.getItem('twoFactorAuth');
  return {
    twoFactorAuth: twoFactorAuth ? JSON.parse(twoFactorAuth) : null,
  };
};

export const removeTwoFactorAuth = () => {
  localStorage.removeItem('twoFactorAuth');
};
